import {
  Layout,
  LayoutAside,
  LayoutBody,
  LayoutContent,
  LayoutHeader,
} from "@/client/components/layout";
import { Badge } from "@/client/components/shad/badge";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/client/components/shad/breadcrumb";
import { Button } from "@/client/components/shad/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/client/components/shad/card";
import { AdminConfigForm } from "@/client/forms/admin";
import { useAuth } from "@/client/hooks/useAuth";
import { IconArrowBack, IconEdit } from "@tabler/icons-react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { UserCard } from "../-features/UserCard";

export const Route = createFileRoute("/(protected)/settings/admin/new-user/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { user } = useAuth();

  return (
    <Layout>
      <LayoutHeader>
        <Breadcrumb>
          <BreadcrumbList className="font-bold text-base">
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/settings/admin">Admin</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>New User</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </LayoutHeader>
      <LayoutContent>
        <LayoutBody>
          <AdminConfigForm />
        </LayoutBody>
        <LayoutAside>
          <div className="h-full space-y-6 animate-in fade-in duration-500">
            <UserCard>
              <Button asChild size="sm" variant="secondary">
                <Link to="/settings/admin">
                  <IconArrowBack />
                  Back
                </Link>
              </Button>
            </UserCard>
            {/*<Card>
              <CardHeader>
                <CardTitle className="flex gap-2 items-center">
                  New User
                  <Badge className="bg-sky-50 text-sky-700 dark:bg-sky-950 dark:text-sky-300">
                    User
                  </Badge>
                </CardTitle>
                <CardDescription>
                  Descripting for the current status of Skopa
                </CardDescription>
              </CardHeader>
              <CardContent>Status content</CardContent>
            </Card>*/}
          </div>
        </LayoutAside>
      </LayoutContent>
    </Layout>
  );
}
